import React from 'react';
import { storeData } from '../../data/storeData';
import StoreTemplate from '../../components/StoreTemplate';
import sw9thImg from '../../assets/images/noahsoutside.jpg';

function SW9th() {
    return <StoreTemplate storeData={storeData.sw9th} storeImage={sw9thImg} />;
}

export default SW9th; 